<form class="f-col blank-form">
    <div class="section-heading">
        <h2 class="h2-heading">{{ approvalManageContent?.['b2b.manageapproval.approvers'] }} <div class="dot">.</div> <span class="optional">{{ content?.['b2b.booking.optional'] }}</span></h2>
    </div>

    <div class="section-content">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.product']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
                        <mat-select>
                            <mat-option>
                                {{ manageTravelerDataContent?.['b2b.managetraveler.option1'] }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.travelcategory']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
                        <mat-select>
                            <mat-option>
                                {{ manageTravelerDataContent?.['b2b.managetraveler.option1'] }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.totalapprovers']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
                        <mat-select>
                            <mat-option>
                                {{ manageTravelerDataContent?.['b2b.managetraveler.option1'] }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-contentsection">
            <h4 class="subheading">{{content?.['b2b.manageapproval.inpolicy']}}
            </h4>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level1']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level2']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level3']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-contentsection">
            <h4 class="subheading">{{content?.['b2b.manageapproval.outofpolicy']}}
            </h4>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level1']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level2']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.level3']}}</mat-label>
                        <input matInput>
                    </mat-form-field>
                </div>
            </div>
        </div>
        

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="cancelApprovers()">{{content?.['b2b.manageapproval.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="saveApprovers()">{{content?.['b2b.manageapproval.save']}}</button>
        </div>
    </div>
</form>
